import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from './AuthContext';
import { getRoleHomePath } from './role-home';

// #1746 — catch-all do App: rota desconhecida volta para a home do papel, não
// para `/` (que platform e monitor não podem ver).
function RoleHomeRedirect() {
  const { role } = useContext(AuthContext);
  return <Navigate to={getRoleHomePath(role)} replace />;
}

export default RoleHomeRedirect;
